import {apiUrl} from '../config/api'

// Public fetch for client use (list only)
export async function fetchDeliveryLocations() {
    const res = await fetch(apiUrl('/api/delivery-locations'), {
        headers: {'Accept': 'application/json'},
    })
    if (!res.ok) {
        throw new Error(`Failed to fetch delivery locations (${res.status})`)
    }
    const data = await res.json()
    return normalizeLocations(Array.isArray(data) ? data : [])
}

// Admin variant: returns ALL locations including ones flagged is_customer_visible=false.
// Use this for admin pages (fee mapping, off-platform create, captain preferences, etc.).
export async function listDeliveryLocations() {
    const res = await fetch(apiUrl('/api/delivery-locations?includeHidden=true'), {
        headers: { 'Accept': 'application/json' },
        credentials: 'include',
    })
    if (!res.ok) throw new Error(await res.text())
    return res.json()
}

export async function createDeliveryLocation(payload) {
    const res = await fetch(apiUrl('/api/delivery-locations'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(payload),
    })
    if (!res.ok) throw new Error(await res.text())
    return res.json()
}

export async function updateDeliveryLocation(id, payload) {
    const res = await fetch(apiUrl(`/api/delivery-locations/${id}`), {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(payload),
    })
    if (!res.ok) throw new Error(await res.text())
    return res.json()
}

export async function deleteDeliveryLocation(id) {
    const res = await fetch(apiUrl(`/api/delivery-locations/${id}`), {
        method: 'DELETE',
        credentials: 'include',
    })
    if (!res.ok) throw new Error(await res.text())
    return true
}

function normalizeLocations(items) {
    return items
}